export default "__VITE_ASSET__KkP4KyNT__"